export const UPDATE_PERMISSOES = "UPDATE_PERMISSOES";
